import {AxiosInstance} from 'axios'
import MyAxiosInstancePriceResearch from './axiosInstancePriceResearch'

// Contratação direta por inexigibilidade (art. 74). Mesmo backend /v1 do price-research.
export interface ReferenciaInex {
    contratante?: string
    natureza?: string
    data?: string
    valor?: number
    fonte?: string
    link?: string
    objeto?: string
}
export interface DadosInexigibilidade {
    orgao?: string
    processo?: string
    data_documento?: string
    objeto?: string
    fornecedor_nome?: string
    cnpj?: string
    hipotese?: string
    preco_proposto?: number
    referencias: ReferenciaInex[]
    fundamentacao?: string
    responsavel?: string
}

export class InexigibilidadeApiService {
    private api: AxiosInstance

    constructor() {
        this.api = MyAxiosInstancePriceResearch
    }

    async buscarPncp(nome: string, cnpj: string): Promise<{total: number; referencias: ReferenciaInex[]; erro?: string}> {
        const {data} = await this.api.get('/inexigibilidade/pncp', {params: {nome, cnpj}})
        return data
    }

    // Assistente "✨ preencher com IA".
    async assistente(
        campo: string,
        dados: Record<string, any>
    ): Promise<{texto?: string; erro?: string}> {
        const {data} = await this.api.post('/assistente', {campo, dados})
        return data
    }

    async verDocumento(dados: DadosInexigibilidade): Promise<void> {
        const {data} = await this.api.post('/inexigibilidade/documento', dados, {
            params: {formato: 'html'},
            responseType: 'blob',
        })
        const url = window.URL.createObjectURL(new Blob([data], {type: 'text/html'}))
        window.open(url, '_blank')
        setTimeout(() => window.URL.revokeObjectURL(url), 60000)
    }

    async baixarPdf(dados: DadosInexigibilidade): Promise<void> {
        const {data} = await this.api.post('/inexigibilidade/documento', dados, {
            params: {formato: 'pdf'},
            responseType: 'blob',
        })
        const url = window.URL.createObjectURL(new Blob([data], {type: 'application/pdf'}))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'inexigibilidade.pdf')
        document.body.appendChild(link)
        link.click()
        link.parentNode?.removeChild(link)
        window.URL.revokeObjectURL(url)
    }

    async baixarWord(dados: DadosInexigibilidade): Promise<void> {
        const {data} = await this.api.post('/inexigibilidade/documento', dados, {
            params: {formato: 'docx'},
            responseType: 'blob',
        })
        const url = window.URL.createObjectURL(new Blob([data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'inexigibilidade.docx')
        document.body.appendChild(link)
        link.click()
        link.parentNode?.removeChild(link)
        window.URL.revokeObjectURL(url)
    }

    async salvar(dados: DadosInexigibilidade): Promise<{id: string; situacao: string}> {
        const {data} = await this.api.post('/inexigibilidade', dados)
        return data
    }

    async listar(): Promise<{itens: any[]}> {
        const {data} = await this.api.get('/inexigibilidade')
        return data
    }
}
